import { Box, styled, Typography } from '@mui/material';

export const Wrapper = styled(Box)`
  width: 700px;
`;

export const AssemblyContainer = styled(Box)`
  margin-top: 30px;
`;

export const AssemblyTagContainer = styled(Box)`
  margin-top: 20px;
`;

export const NameContainer = styled(Typography)`
  text-align: center;
  padding-top: 5px;
`;

export const ErrorContainer = styled(Typography)(
  ({ theme }) => `color ${theme.palette.brand.red};
font-size:12px;`,
);
export const ChipContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 10px;
`;
